import { http } from "./http"
import { Country } from "models/common"
import { Paginated } from "./types"

export const fetchCountries = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("countries", { searchParams }).json()
  return res as Paginated<Country>
}

export const fetchCountriesByRegion = async (
  _key: string,
  regionCode: string,
) => {
  const searchParams = new URLSearchParams({ regionCode })
  const res = await http.get("countries", { searchParams }).json()
  return res as Paginated<Country>
}
